// Redux is a bit too much for what I'm trying to do here
// most of the operations are going to be server-side, so
// state management shouldn't be too complicated

import { createWithEqualityFn as create } from 'zustand/traditional';
import db from '@utils/db';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
import { Client } from './partials/client';
import { RegistrationViewType } from '@models/RegistrationViewType';
import moment, { Moment } from 'moment';
import { SearchFilterType } from '@models/SearchFilterType';
import versionJson from '@src/version.json';
import { immer } from './immer';
import ScheduleItem from '@models/ScheduleItem';
import AllDayMarkingArr from '@models/AllDayMarkingArr';
import axios from 'axios';
import Student from '@models/Student';

const instance = axios.create();

export enum LISTSELECTION_TYPE {
  STUDENT = 'student',
  COURSE = 'course',
}

const initialState = {
  apiUrl: null,
  checkin: null,
  activeFilter: -1,
  dateFilter: false,
  currentcam: 0,
  cameraList: [],
  splash: false,
  updateCheck: false,
  schools: null,
  multiLogin: 0,
  wondeTags: null,
  alerts: null,
  appVer: versionJson.version,
  caseworkerId: null,
  caseWorkerEmail: null,
  user: null,
  otherUser: null,
  teams: false,
  initialRegistrationTypes: null,
  allowedDates: [],
  language: 'en',
  settings: null,
  token: null,
  tenantId: null,
  clientSettings: null,
  systemSettings: null,
  noteUserId: null,
  pinnedStudents: null,
  pinnedCounselorStudents: null,
  guardianStudents: null,
  selectedGuardianStudent: null,
  notificationCounter: 0,
  updateNow: false,
  schoolLeaderView: 0,
  schoolViewDateRange: 1,
  kohortsAvailable: false,
  courseClick: null,
  showInfoBubble: {
    show: null,
    text: null,
  },
  teacherStudentList: {
    loading: false,
    data: [],
  },
  teacherSelection: {
    name: null,
    val: null,
    type: null,
  },
  teacherSelectedStudent: { firstname: '', lastname: '', id: '' },
  adminStore: {
    name: null,
    val: null,
    type: null,
  },
  teacherStore: {
    name: null,
    val: null,
    type: null,
  },
  scheduleIndex: 0,
  client: null,
  ids: null,
  students: {
    data: null,
    loading: false,
    needsRefetch: false,
  },
  permissions: [],
  loading: false,
  scheduleId: '',
  searchQuery: '',
  student: null,
  counselorStudent: null,
  course: null,
  searchFilters: [SearchFilterType.STUDENT, SearchFilterType.COURSE],
  menuOpen: false,
  filterOpen: false,
  searchOpen: false,
  mobileOptionsOpen: false,
  callNameSetting: null,
  registrationFor: {
    name: null,
    val: null,
    type: null,
    id: null,
  },
  searchResults: {
    data: null,
    loading: false,
  },
  schedule: {
    data: null,
    loading: false,
  },
  error: {
    schedule: null,
    students: null,
    popup: null,
  },
  registrationIndex: 0,
  adminStudentList: [],
  adminSelection: {
    name: null,
    val: null,
    type: null,
  },
  courseAdminSelection: {
    name: null,
    val: null,
    type: null,
  },
  adminSelectedStudent: {
    firstname: '',
    lastname: '',
    id: '',
    sis_id: '',
  },
  adminSelectedWrittenAbsence: {
    id: '',
    name: '',
    assignment: null
  },
  listSelection: {
    data: [],
    lastSelection: null,
    selectionIndex: 0,
  },
  whoIsLoggedIn: {
    firstname: '',
    lastname: '',
  },
  tutorial: false,
  groups: null,
  fromDate: '',
  toDate: '',
  note: false,
  selectedStudent: {
    firstname: '',
    sis_id: '',
    changes: false,
    duration: null,
  },
  selectedCount: 0,
  semesters: null,
  filterDate: {
    text: null,
    year: null,
    from: null,
    to: null,
  },
  rewardScreen: false,
  reward: false,
  rewardPreview: false,
  preview: false,
  rewardScreenBadge: null,
  badge: null,
  screenType: { type: null, show: false },
  coins: {
    newCoins: 1231,
    currentCoins: 0,
    oldCoins: 0,
    coins: 913,
    animate: false,
  },
  studentName: null,
  QRScreen: false,
  hideAbsenceMenu: true,
  filterWarning: null,
  infoBubbleArray: [],
  infoBubbleCount: 0,
  mobileLogin: null,
  rewardQRScreen: false,
  selectedCaseworker: null,
  caseworkers: [],
  alertInfo: {
    open: false,
    active: false,
    students: []
  },
  schoolName: null,
  selectedSchoolViewSearch: null,
  schoolViewRegistrations: null,
  schoolViewTags: [],
  schoolViewKohorts: null,
  schooolViewStudents: null,
  schoolViewCourses: null,
  schoolViewNotes: null,
  schoolViewApprovals: null,
  schoolViewFilter: { subjects1: [], percentage1: 0, percentage_worst1:0, percentage_best1:0, percentage2: 0, percentage3: 0, percentage8: 0, search: '', search1: '', search2: '', search3: '', search4: '', search5: '', search8: '', search10: '', active: true, inactive: true, tags: [], types: [], courses1: [], courses3: [], fromDate0: new Date(), toDate0: new Date(), fromDate3: null, toDate3: null, fromDate4: null, toDate4: null, quickfilter0: 0, quickfilter3: 3, quickfilter4: 5, quickDays: 30, advanced: false },
  page: 1,
  cameraInfo: null,
  highLightDates: [],
  selectedSemester: null,
  selectedKohort: null,
  popupLogin: false,
  // Signed in, but the login token can no longer be renewed silently - shows the "sign in again"
  // prompt (SessionExpiredPrompt).
  sessionExpired: false,
  // A newer build is live than the one this tab is running (useVersionCheck) - shows the
  // "new version available" bar.
  newVersionAvailable: false,
};
const store = (set, get) => ({
  ...initialState,
  updateLastSelection: (type: LISTSELECTION_TYPE, index: number = 0) => {
    set((state) => {
      state.listSelection.lastSelection = type;
      state.listSelection.selectionIndex = index;
    });
  },
  updateListStudents: async (jsonList: AllDayMarkingArr[], username: string, date: Moment, type: string, lateMinutes: number) => {
    set((state) => {
      jsonList.forEach((item) => {
        const studentIndex = state.students.data.findIndex((student) => student.sis_id === item.student_id);
        if (studentIndex > -1) {
          let reservationIndex = state.students.data[studentIndex].reservations.findIndex(
            (reservation) => reservation.id === item.timeblock_id,
          );
          if (reservationIndex > -1) {
            let initial = state.initialRegistrationTypes.find(
              (t) => t.initial_Registration_Method === state.students.data[studentIndex].reservations[reservationIndex].initial_Method,
            );
            let newStatus =
              state.students.data[studentIndex].reservations[reservationIndex].initial_Method !== null &&
                state.students.data[studentIndex].reservations[reservationIndex].initial_Method !== undefined &&
                state.students.data[studentIndex].reservations[reservationIndex].initial_Method !== 0 &&
                item.type === -1
                ? initial.registration_Type
                : item.type;
            item.reset_bit = item.type === -1 && newStatus !== item.type;
            item.lateminutes = lateMinutes;
            item.type = newStatus;
          }
        }
      });

      state.students.loading = true;
    });

    const jsonStr = JSON.stringify(jsonList);
    const res = await db.Regi_MarkStudents4AllDayView(jsonStr);

    set((state) => {
      state.students.loading = false;
      if (res === 0) {
        jsonList.forEach((item) => {
          // console.log('jsonList.item', item);
          if (state.students && state.students.data && state.students.data.length > 0) {
            const studentIndex = state.students.data.findIndex((student) => student.sis_id === item.student_id);
            if (studentIndex > -1) {
              // console.log('studentIndex', studentIndex);
              let reservationIndex = state.students.data[studentIndex].reservations.findIndex(
                (reservation) => reservation.id === item.timeblock_id,
              );
              if (reservationIndex > -1) {
                state.students.data[studentIndex].reservations[reservationIndex].type = item.type;
                state.students.data[studentIndex].reservations[reservationIndex].tag_ids = item.tag_ids;
              }
            }
          }
        });
      }
    });
    // const newStudents = (await db.Regi_GetStudents4AllDayView(username, moment(date), type)) as ListviewStudent[];
    // remove students loading on received update
  },
  updateAllListSelectionStudents: () => {
    set((state) => {
      const checkStatus = Object.values(state.listSelection.data).every((student: any) =>
        Object.values(student.reservations).every(Boolean),
      );
      if (checkStatus) {
        Object.keys(state.listSelection.data).forEach((studentId) => {
          Object.keys(state.listSelection.data[studentId].reservations).forEach((reservation) => {
            state.listSelection.data[studentId].reservations[reservation] = false;
          });
        });
      } else {
        Object.keys(state.listSelection.data).forEach((studentId) => {
          Object.keys(state.listSelection.data[studentId].reservations).forEach((reservation) => {
            state.listSelection.data[studentId].reservations[reservation] = true;
          });
        });
      }
    });
  },
  massUpdateListSelectionTimeblock: (reservationID: string) => {
    set((state) => {
      const checkStatus = Object.values(state.listSelection.data).every((student: any) => student.reservations[reservationID] !== false);

      if (checkStatus) {
        // if true, set all object items to false, otherwise true
        Object.keys(state.listSelection.data).forEach((key) => {
          state.listSelection.data[key].reservations[reservationID] = false;
        });
      } else {
        Object.keys(state.listSelection.data).forEach((key) => {
          state.listSelection.data[key].reservations[reservationID] = true;
        });
      }
    });
  },
  massUpdateListSelectionStudent: (studentID: string) => {
    set((state) => {
      const matchingStudentIndex = state.listSelection.data.findIndex((student) => student.sis_id === studentID);
      if (matchingStudentIndex > -1) {
        const checkStatus = Object.values(state.listSelection.data[matchingStudentIndex].reservations).every(Boolean);
        if (checkStatus) {
          // if true, set all object items to false, otherwise true
          Object.keys(state.listSelection.data[matchingStudentIndex].reservations).forEach((key) => {
            state.listSelection.data[matchingStudentIndex].reservations[key] = false;
          });
        } else {
          Object.keys(state.listSelection.data[matchingStudentIndex].reservations).forEach((key) => {
            state.listSelection.data[matchingStudentIndex].reservations[key] = true;
          });
        }
      }
    });
  },
  updateListSelection: (reservationID: string, studentID: string) => {
    set((state) => {
      const index = state.listSelection.data.findIndex((student) => student.sis_id === studentID);
      if (index > -1) {
        state.listSelection.data[index].reservations[reservationID] = !state.listSelection.data[index].reservations[reservationID];
      }
    });
  },
  resetListSelection: () =>
    set((state) => {
      state.listSelection.data = [];
    }),
  setListSelection: (students: Student[]) => {
    set((state) => {
      state.listSelection.data = [];
      if (!students) return;
      let result = students.map((student) => {
        let mappedReservations = {};
        student.reservations?.forEach((reservation) => {
          mappedReservations[reservation.id] = false;
        });
        return {
          sis_id: student.sis_id,
          reservations: mappedReservations,
        };
      });
      state.listSelection.data = result;
    });
  },
  setAllowedDates: (dates: any[]) => {
    set({ allowedDates: dates });
  },
  setRegistrationFor: (name: string, val: any, type: string, id: string = null) => {
    set({ registrationFor: { name, val, type, id } });
    if (val) {
      set({ searchQuery: '' });
    }
  },
  setError: (errorType: string, error: string) =>
    set((state) => {
      state.error[errorType] = error;
    }),

  clearRegistrationFor: () =>
    set((state) => {
      state.registrationFor.name = null;
      state.registrationFor.val = null;
      state.registrationFor.type = null;
    }),
  setRegistrationIndex: (registrationIndex: number) => set({ registrationIndex }),
  search: async (
    searchQuery: string = '',
    admin: boolean = false,
    username: string,
    customSearchSP?: string,
    superAdmin?: boolean,
    days?: number,
  ) => {
    set((state) => {
      state.searchQuery = searchQuery;
      state.searchResults.loading = true;
    });
    let data = null;
    if (searchQuery && searchQuery?.length > 1 && username) {
      data = await db.search(searchQuery, admin, username, customSearchSP, superAdmin, days);
    }
    // A newer search started meanwhile (the search fields send whole terms while typing pauses) - this
    // answer is out of date, don't let it replace the newer one.
    if (get().searchQuery !== searchQuery) return;
    set({ searchResults: { loading: false, data } });
  },
  writtensearch: async (
    searchQuery: string = '',
    username: string
  ) => {
    set((state) => {
      state.searchQuery = searchQuery;
      state.searchResults.loading = true;
    });
    let data = null;
    if (searchQuery && searchQuery?.length > 1) {
      data = await db.WrittenSearch(searchQuery, username);
    }
    set({ searchResults: { loading: false, data } });
  },
  clearSearch: () => {
    set({
      searchQuery: '',
      searchResults: { data: null, loading: false },
      searchOpen: false,
      registrationIndex: 0,
      registrationFor: { name: null, val: null, type: null },
      schedule: { data: null, loading: false },
      students: { data: null, loading: false, needsRefetch: false },
    });
  },
  setScheduleRegistration: (status: boolean) => {
    set((state) => {
      if (state.schedule.data && state.schedule.data.length > 0) {
        state.schedule.data[state.scheduleIndex].markregistered = status;
      }
    });
  },
  setAllDayScheduleRegistration: (status: boolean) => {
    set((state) => {
      if (state.schedule.data && state.schedule.data.length > 0) {
        for (let i = 0; i < state.schedule.data.length; i++) {
          state.schedule.data[i].markregistered = status;
        }
      }
    });
  },
  setAllDayScheduleRegistrationIds: (status: boolean, ids: any) => {
    set((state) => {
      if (state.schedule.data && state.schedule.data.length > 0) {
        for (let i = 0; i < state.schedule.data.length; i++) {
          if (ids.some((id) => state.schedule.data[i].id === id)) state.schedule.data[i].markregistered = status;
        }
      }
    });
  },
  setUser: (user: any) => set({ user }),
  setOtherUser: (otherUser: any) => set({ otherUser }),
  setSearchFilters: (searchFilters: SearchFilterType[]) => set({ searchFilters }),
  setMenuOpen: (menuOpen: boolean) => set({ menuOpen }),
  setFilterOpen: (filterOpen: boolean) => set({ filterOpen }),
  setPermissions: (permissions: any[]) => set({ permissions }),
  setMobileOptionsOpen: (mobileOptionsOpen: boolean) => set({ mobileOptionsOpen }),
  setSearchOpen: (searchOpen: boolean) => set({ searchOpen }),
  setClientData: (client: Client) => set({ client }),
  setSettings: (settings: any) => set({ settings }),
  settoken: (token: any) => set({ token }),
  setStudentsLoading: (status: boolean) =>
    set((state) => {
      state.students.loading = status;
    }),
  updateStudent: (student: string, reservationIds?: any) =>
    set((state) => {
      let studentItem = state.students.data.find((s) => s.sis_id === student);
      if (reservationIds) {
        studentItem.notePresent = true;
        for (let i = 0; i < studentItem.reservations.length; i++) {
          if (reservationIds.some((r) => r.reservationId === studentItem.reservations[i].id)) {
            studentItem.reservations[i].type = 2;
            studentItem.reservations[i].initial_Method = 1;
          }
        }
      } else {
        studentItem.initial_Method = 1;
        studentItem.type = 2;
        studentItem.notePresent = true;
      }
    }),
  updateRegistrationStudent: (student: string, absence_type: number, text: string, tag_ids: string, duration?: number) =>
    set((state) => {

      let studentItem = state.students.data.find((s) => s.sis_id === student);
      studentItem.type = absence_type;
      studentItem.note = text;
      studentItem.tag_ids = tag_ids
      if (absence_type === 3) studentItem.duration = (duration * 60)
    }),
  resetStudent: (student: string, reservationIds?: any) =>
    set((state) => {
      let studentItem = state.students.data.find((s) => s.sis_id === student);
      if (reservationIds) {
        for (let i = 0; i < studentItem.reservations.length; i++) {
          if (reservationIds.some((r) => r.reservationId === studentItem.reservations[i].id)) {
            studentItem.reservations[i].type = -1;
            studentItem.reservations[i].initial_Method = 0;
          }
        }
      } else {
        studentItem.initial_Method = 0;
        studentItem.type = -1;
      }
    }),
  updateStudentNote: (student: string) =>
    set((state) => {
      let studentItem = state.students?.data?.find((s) => s.sis_id === student);

      if (studentItem) {
        studentItem.notePresent = true;
        studentItem.noteUnreadCount = studentItem.noteUnreadCount++;
      }
    }),
  setScheduleLoading: (status: boolean) =>
    set((state) => {
      state.schedule.loading = status;
    }),
  setStudents: (students: any[]) => {
    if (students && students?.length > 0) {
      set({ students: { data: students, loading: false } });
      return;
    }
    set({ students: { data: null, loading: false } });
  },
  setregistrationView: (registrationView: RegistrationViewType) => set({ registrationView }),
  setSchedule: async (data: ScheduleItem[]) => {
    set({ schedule: { data: data, loading: false } });
  },
  setScheduleIndex: (scheduleIndex: number) => set({ scheduleIndex }),
  updateRegistration: async (
    studentId: string,
    timeblockId: string,
    status: number,
    username: string,
    index: number = -1,
    date: Moment = moment(),
    fromDate: Moment,
    toDate: Moment,
    lateMinutes: number,
    text?: string,
    tag_ids?: string
  ) => {
    let matchingIndex = 0;
    let oldStatus;
    let isFuture;
    let oldDuration;
    let newStatus = status;
    set((state) => {
      matchingIndex = state.students.data.findIndex((item) => item.sis_id === studentId);
      if (matchingIndex === -1) {
        return state;
      }
      if (index > -1) {
        let initial = state.initialRegistrationTypes.find(
          (t) => t.initial_Registration_Method === state.students.data[matchingIndex].courses[index].initial_Method,
        );
        oldStatus = state.students.data[matchingIndex].courses[index].type;
        oldDuration = state.students.data[matchingIndex].courses[index].duration;
        newStatus =
          state.students.data[matchingIndex].courses[index].initial_Method !== null &&
            state.students.data[matchingIndex].courses[index].initial_Method !== 0 &&
            status === -1
            ? initial.registration_Type
            : status;
        state.students.data[matchingIndex].courses[index].type = newStatus;
        state.students.data[matchingIndex].courses[index].duration = lateMinutes * 60;
      } else {
        let initial = state.initialRegistrationTypes.find(
          (t) => t.initial_Registration_Method === state.students.data[matchingIndex].initial_Method,
        );
        oldStatus = state.students.data[matchingIndex].type;
        oldDuration = state.students.data[matchingIndex].duration;
        newStatus =
          state.students.data[matchingIndex].initial_Method !== null &&
            state.students.data[matchingIndex].initial_Method !== 0 &&
            status === -1
            ? initial.registration_Type
            : status;
        state.students.data[matchingIndex].type = newStatus;
        state.students.data[matchingIndex].duration = lateMinutes * 60;
        if (text || (!text && state.students.data[matchingIndex].note)) state.students.data[matchingIndex].note = text;
        if (tag_ids || (!tag_ids && state.students.data[matchingIndex].tag_ids)) state.students.data[matchingIndex].tag_ids = tag_ids
      }
      state.students.data[matchingIndex].loading = true;
      isFuture = moment(date).isAfter(moment());
    });
    // The student as they are in the list *now*. Everything below runs after a request, and by then the
    // teacher may have moved to another lesson/date: the list is reset (students.data = null) or holds
    // other students, so the position found above (matchingIndex) can be missing or someone else.
    const updateThisStudent = (update: (student: any) => void) =>
      set((state) => {
        const student = state.students?.data?.find((item) => item.sis_id === studentId);
        if (student) update(student);
      });

    if (isFuture) {
      updateThisStudent((student) => {
        student.loading = false;
      });
    }

    const success = await db.Regi_MarkStudentStatusByTimeBlockIDAndStudentId(
      timeblockId,
      studentId,
      newStatus,
      username,
      false,
      lateMinutes,
      status === -1 && newStatus !== status,
      tag_ids,
      text,
      false
    );

    if (!success && success !== 0) {
      updateThisStudent((student) => {
        if (index > -1) {
          if (student.courses?.[index]) {
            student.courses[index].type = oldStatus;
            student.courses[index].duration = oldDuration;
          }
        } else {
          student.type = oldStatus;
          student.duration = oldDuration;
        }
        student.loading = true;
      });
    }
    else {
      if (status === 2 || status === 3) {
        //await db.CreateEventInQueue(studentId, 1, 10, timeblockId);
      }
    }

    if (isFuture) {
      updateThisStudent((student) => {
        student.loading = false;
      });
      return;
    }

    const updated_student = await db.Stats_GetAbsenceByStudentIDAndOrTimeBlockID(studentId, timeblockId, fromDate, toDate);
    updateThisStudent((student) => {
      // No answer: keep the percentages already shown.
      if (updated_student) {
        student.total_percentage = updated_student[0]?.total_percentage;
        student.course_percentage = updated_student[0]?.course_percentage;
      }
      student.loading = false;
    });
  },
  massUpdateRegistration: async (
    timeblockId: string,
    type: any,
    username: string,
    note_type_id: number,
    date: Moment = moment(),
    fromDate: Moment,
    toDate: Moment,
    lateMinutes,
  ) => {
    let clone = [];
    let isinFuture = false;
    isinFuture = moment(date).isAfter(moment());

    set((state) => {
      for (let index = 0; index < state.students.data.length; index++) {
        clone.push(state.students.data[index].type);
        if (type === -1 && state.students.data[index].initial_Method !== null && state.students.data[index].initial_Method !== 0) {
          let initial = state.initialRegistrationTypes.find(
            (t) => t.initial_Registration_Method == state.students.data[index].initial_Method,
          );
          state.students.data[index].type = initial.registration_Type;
        } else state.students.data[index].type = type;
        if (!isinFuture) {
          state.students.data[index].loading = true;
        }
      }
    });

    const res = await db.Regi_MarkAllStudentsStatusByTimeBlockID(timeblockId, type, username, false, lateMinutes);

    if (!res && res !== 0) {
      // If mark all fails, revert to unknown
      set((state) => {
        for (let index = 0; index < state.students.data.length; index++) {
          state.students.data[index].loading = false;
          state.students.data[index].type = clone[index];
        }
      });
    } else {
      if (!isinFuture) {
        set((state) => {
          for (let index = 0; index < state.students.data; index++) {
            // console.log(state.students.data[index]);
            state.students.data[index].loading = true;
          }
        });
        const res = await db.Regi_GetStudentsByTimeBlockId(timeblockId, username, note_type_id, fromDate, toDate);
        if (res.length > 0) {
          set((state) => {
            if (type === 2 || type === 3) {
              res.forEach(async element => {
                //await db.CreateEventInQueue(element.sis_id, 1, 10, timeblockId);
              });
            }

            for (let idx = 0; idx < res.length; idx++) {
              // check if students id's match with student id's in state

              const matchingIndex = state.students.data?.findIndex((item) => item.sis_id === res[idx].sis_id);
              // if they do, updatestudentabsence
              if (matchingIndex > -1) {
                if (type === -1) {
                  state.students.data[matchingIndex].type = res[idx].type;
                }
                state.students.data[matchingIndex].total_percentage = res[idx].total_percentage;
                state.students.data[matchingIndex].total_percentage = res[idx].total_percentage;
                state.students.data[matchingIndex].course_percentage = res[idx].course_percentage;
                state.students.data[matchingIndex].loading = false;
              }
            }
          });
        }
      }
    }
  },
  setLanguage: (lang: string) => set({ language: lang }),
  setStudentName: (name: string) => set({ studentName: name }),
  setAdminSelection: (name: string, val: any, type: string, id: string) => {
    set({ adminSelection: { name, val, type, id } });
    if (val) {
      set({ searchQuery: '' });
    }
  },
  setCourseAdminSelection: (name: string, val: any, type: string, id: string) => {
    set({ courseAdminSelection: { name, val, type, id } });
  },
  setAdminStudentList: (adminStudentList: Array<any>) => set(() => ({ adminStudentList })),
  setAdminSelectedStudent: (firstname: string, lastname: string, id: string, sis_id: string) => {
    set({ adminSelectedStudent: { firstname, lastname, id, sis_id } });
  },
  setAdminSelectedWrittenAbsence: (id: string, name: string, assignment: any) => {
    set({ adminSelectedWrittenAbsence: { name, id, assignment } });
  },
  setTeacherSelection: (name: string, val: any, type: string) => {
    set({ teacherSelection: { name, val, type } });
    if (val) {
      // set({ adminSelectedStudent: { firstname: null, lastname: null, id: null } });
      set({ searchQuery: '' });
    }
  },
  setTeacherStudentList: (list: Array<any>) =>
    set((state) => {
      state.teacherStudentList.data = list;
      state.teacherStudentList.loading = false;
    }),
  setTeacherStudentListLoading: (bool: boolean) =>
    set((state) => {
      state.teacherStudentList.loading = bool;
    }),
  setTeacherSelectedStudent: (firstname: string, lastname: string, id: string) => {
    set({ teacherSelectedStudent: { firstname, lastname, id } });
  },
  setWhoIsLoggedIn: (firstname: string, lastname: string) => {
    set({ whoIsLoggedIn: { firstname, lastname } });
  },
  setTutorial: (tutorial: boolean) => set({ tutorial }),
  setGroups: (groups: Array<any>) => set({ groups }),
  setFromDate: (fromDate: string) => set({ fromDate }),
  setToDate: (toDate: string) => set({ toDate }),
  setNote: (note: boolean) => set({ note }),
  setSelectedStudent: (firstname: string, sis_id: string, changes?: boolean, duration?) => {
    set({ selectedStudent: { firstname, sis_id, changes, duration } });
  },
  setSelectedCount: (selectedCount: number) => set({ selectedCount }),
  setFilterDate: (text: any, year: string, from: any, to: any, enddate: any) => {
    set({ filterDate: { text, year, from, to, enddate } });
  },
  setTenantId: (tenantId: string) => set({ tenantId }),
  setSemesters: (semesters: any) => set({ semesters }),
  setClientSettings: (clientSettings: any) => set({ clientSettings }),
  setSystemSettings: (systemSettings: any) => set({ systemSettings }),
  setRewardScreen: (rewardScreen: boolean) => set({ rewardScreen }),
  setPreview: (preview: boolean) => set({ preview }),
  setReward: (reward: boolean) => set({ reward }),
  setRewardPreview: (rewardPreview: boolean) => set({ rewardPreview }),
  setNoteUserId: (noteUserId: string) => set({ noteUserId }),
  setShowInfoBubble: (show: boolean, text: string) => set({ showInfoBubble: { show, text } }),
  setRewardScreenBadge: (rewardScreenBadge: any) => set({ rewardScreenBadge }),
  setBadge: (badge: any) => set({ badge }),
  setIds: (ids: any) => set({ ids }),
  setCourse: (course: any) => set({ course }),
  setStudent: (student: any) => set({ student }),
  setCounselorStudent: (counselorStudent: any) => set({ counselorStudent }),
  setSelectedGuardianStudent: (selectedGuardianStudent: string) => set({ selectedGuardianStudent }),
  setScreenType: (screenType: any) => set({ screenType }),
  // } as IAppStore);
  setCoins: (newCoins: number, currentCoins: number, oldCoins: number, coins: number, animate: boolean) => {
    set({ coins: { newCoins, currentCoins, oldCoins, coins, animate } });
  },
  setQRScreen: (QRScreen: boolean) => set({ QRScreen }),
  setMobileLogin: (mobileLogin: boolean) => set({ mobileLogin }),
  setSafeArea: (safeArea: any) => set({ safeArea }),
  reset: () => set(initialState),
  setInitialRegistrationTypes: (initialRegistrationTypes: any) => set({ initialRegistrationTypes }),
  setHideAbsenceMenu: (hideAbsenceMenu: boolean) => set({ hideAbsenceMenu }),
  setCallNameSetting: (callNameSetting: string) => set({ callNameSetting }),
  setPinnedStudents: (pinnedStudents: any) => set({ pinnedStudents }),
  setPinnedCounselorStudents: (pinnedCounselorStudents: any) => set({ pinnedCounselorStudents }),
  setFilterWarning: (filterWarning: boolean) => set({ filterWarning }),
  setInfoBubbleArray: (text: string) =>
    set((state) => {
      state.infoBubbleCount++;
      let temp = state.infoBubbleArray;
      temp.push({ id: state.infoBubbleCount, text: text });
      state.infoBubbleArray = temp;
    }),
  RemoveInfoBubble: (arrId: any) =>
    set((state) => {
      const newList = state.infoBubbleArray?.filter((item) => !arrId.includes(item.id));
      state.infoBubbleArray = newList;
    }),
  setRewardQRScreen: (rewardQRScreen: boolean) => set({ rewardQRScreen }),
  setCaseWorkerId: (caseworkerId: string) => set({ caseworkerId }),
  setCaseWorkerEmail: (caseWorkerEmail: string) => set({ caseWorkerEmail }),
  setAlertInfo: (alertInfo: any) => set({ alertInfo }),
  setAlerts: (alerts: any) => set({ alerts }),
  setSelectedCaseworker: (selectedCaseworker: any) => set({ selectedCaseworker }),
  setCaseworkers: (caseworkers: any) => set({ caseworkers }),
  setSchoolName: (schoolName: any) => set({ schoolName }),
  setWondeTags: (wondeTags: any) => set({ wondeTags }),
  setMultiLogin: (multiLogin: any) => set({ multiLogin }),
  setSchools: (schools: any) => set({ schools }),
  setGuardianStudents: (guardianStudents: any) => set({ guardianStudents }),
  setNotificationCounter: (notificationCounter: number) => set({ notificationCounter }),
  setUpdateCheck: (updateCheck: boolean) => set({ updateCheck }),
  setSplash: (splash: boolean) => set({ splash }),
  setCameraList: (cameraList: any) => set({ cameraList }),
  setCurrentCam: (currentCam: number) => set({ currentCam }),
  setUpdateNow: (updateNow: boolean) => set({ updateNow }),
  setSchoolLeaderView: (schoolLeaderView) => set({ schoolLeaderView }),
  handleNote: (id, studentName) => set({ noteUserId: id, note: true, studentName: studentName }),
  setSchoolViewDateRange: (schoolViewDateRange) => set({ schoolViewDateRange }),
  setSelectedSchoolViewSearch: (selectedSchoolViewSearch) => set({ selectedSchoolViewSearch }),
  setSchoolViewRegistrations: (schoolViewRegistrations) => set({ schoolViewRegistrations }),
  setSchoolViewTags: (schoolViewTags) => set({ schoolViewTags }),
  setSchoolViewStudents: (schooolViewStudents) => set({ schooolViewStudents }),
  setSchoolViewCourses: (schoolViewCourses) => set({ schoolViewCourses }),
  setSchoolViewNotes: (schoolViewNotes) => set({ schoolViewNotes }),
  setSchoolViewApprovals: (schoolViewApprovals) => set({ schoolViewApprovals }),
  setSchoolViewFilter: (schoolViewFilter) => set({ schoolViewFilter }),
  setPage: (page) => set({ page }),
  setCameraInfo: (cameraInfo) => set({ cameraInfo }),
  setActiveFilter: (activeFilter) => set({ activeFilter }),
  setDateFilter: (dateFilter) => set({ dateFilter }),
  setFilterSelected: (filterSelected) => set({ filterSelected }),
  setHighLightDates: (highLightDates) => set({ highLightDates }),
  setSelectedSemester: (selectedSemester) => set({ selectedSemester }),
  setSelectedKohort: (selectedKohort) => set({ selectedKohort }),
  setKohortsAvailable: (kohortsAvailable) => set({ kohortsAvailable }),
  setSchoolViewKohorts: (schoolViewKohorts) => set({ schoolViewKohorts }),
  setCourseClick: (courseClick) => set({ courseClick }),
  setCheckin: (checkin) => set({ checkin }),
  setPopupLogin: (popupLogin) => set({ popupLogin }),
  setSessionExpired: (sessionExpired) => set({ sessionExpired }),
  setNewVersionAvailable: (newVersionAvailable) => set({ newVersionAvailable }),
  setApiUrl: (apiUrl) => set({ apiUrl }),
});

export const useStore = create(devtools(subscribeWithSelector(immer(store))));
